<template>
    <dropdown
        :caret="false"
        :customPopperOptions="{
            strategy: 'fixed',
            placement: 'left-start',
        }"
        class="action-menu"
        toggler-classes="btn-rounded btn-icon"
        @click.stop=""
    >
        <template #toggler>
            <more v-if="!isLoading" />
            <spinner v-else />
        </template>

        <slot />
    </dropdown>
</template>
<script setup>
import Dropdown from '@/Components/Dropdown.vue';
import More from '../../icons/More.vue';

defineProps({ isLoading: { type: Boolean, default: false } });
</script>
